import { valueFormatter } from "components/widgets/chart/insBubbleChart/helpers";
const getDatapointValue = (total, name) => total.datapoints?.find((dp) => dp.name === name)?.value;
export const addTotalFlatLineSeriesVisitor = (params) => (args) => {
    const { totals, customResult } = args.context.staticData;
    const xaxis = args.context.staticData.root?.[0]?.additionalData?.xaxis;
    if (!totals?.length || !xaxis?.length || !customResult?.length) {
        return;
    }
    const grandTotal = totals[totals.length - 1];
    params?.forEach((param) => {
        const { yDatapoint, name: seriesName, type, yAxis, valueFormat, className } = param;
        const value = getDatapointValue(grandTotal, yDatapoint);
        if (value === null || value === undefined) {
            return;
        }
        const y = isNaN(value) ? value?.amount : value;
        if (y === null || y === undefined) {
            return;
        }
        const formattedValue = valueFormatter(y, valueFormat, value?.currency);
        const seriesData = xaxis.map((category) => ({
            custom: { tooltip: [[seriesName, formattedValue]] },
            name: category,
            y
        }));
        const hasSeries = customResult.some((series) => series.name === seriesName);
        if (!hasSeries) {
            customResult.push({
                className,
                data: seriesData,
                metaData: { isTotalSeries: true },
                name: seriesName,
                type,
                yAxis
            });
        }
    });
};
